// Avatar component with initials fallback
// Generates consistent colors based on name

/**
 * Generate a consistent color based on a string (name)
 * @param {string} str - String to generate color from
 * @returns {string} HSL color string
 */
export const getAvatarColor = (str) => {
  if (!str) return 'hsl(210, 50%, 40%)';
  
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Generate vibrant colors with good saturation
  const hue = Math.abs(hash % 360);
  const saturation = 60 + (Math.abs(hash >> 8) % 20); // 60-80%
  const lightness = 35 + (Math.abs(hash >> 16) % 15); // 35-50%
  
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

/**
 * Get initials from a name
 * @param {string} firstName - First name
 * @param {string} lastName - Last name
 * @returns {string} Initials (max 2 characters)
 */
export const getInitials = (firstName, lastName) => {
  const first = (firstName || '').trim().charAt(0).toUpperCase();
  const last = (lastName || '').trim().charAt(0).toUpperCase();
  
  if (first && last) {
    return `${first}${last}`;
  } else if (first) {
    return first;
  } else if (last) {
    return last;
  }
  return '?';
};

/**
 * Get full name from player object
 * @param {object} player - Player object
 * @returns {string} Full name
 */
export const getFullName = (player) => {
  if (!player) return '';
  const firstName = (player.first_name || '').trim();
  const lastName = (player.last_name || '').trim();
  return `${firstName} ${lastName}`.trim();
};

export default { getAvatarColor, getInitials, getFullName };
